import { List, ListItem } from '@mui/material';
import { Box, Button, Typography } from 'hephaestus/web';

type IAccountAgreements = {
  id: string;
  url: string;
};

export const AccountAgreements = ({
  label,
  value,
}: {
  label: string;
  value: any;
  key?: string;
}) => (
  <Box>
    <Typography variant='bodyLarge'>{label}</Typography>
    <List>
      {(value.agreements ?? []).map(({ id, url }: IAccountAgreements) => (
        <ListItem key={id}>
          <Button variant='outlined' size='small' href={url} target='_blank'>
            {url.split('/').pop() ?? ''}
          </Button>
        </ListItem>
      ))}
    </List>
  </Box>
);
